<template>
  <v-app class="mima">
      <v-app-bar  :fixed="$route.path!='/c/affordable-housing-locator'?true:false"  color="white">
        <div class="d-flex align-center mt-4">
          
          <router-link to="/" style="text-decoration:none;color:white">
            <p class="text-h5 font-weight-bold animate__animated animate__fadeIn animate_slow"><v-img width="200" src="./assets/housingmatch.png"></v-img></p>
          </router-link>
        </div>

        <v-spacer></v-spacer>
    <v-btn plain text style="text-transform:none;color:#286738" class="animate__animated animate__fadeIn animate_slow" to="/">Home</v-btn>
    <v-btn plain text style="text-transform:none;color:#286738" class=" animate__animated animate__fadeIn animate_slow" >Services</v-btn>
      <v-btn plain text style="text-transform:none;color:#286738" class="animate__animated animate__fadeIn animate_slow">About</v-btn>
      <v-btn plain text style="text-transform:none;color:#286738" class="animate__animated animate__fadeIn animate_slow">Additional Resources</v-btn>
      
      <v-spacer></v-spacer>


       <v-btn v-if="$route.path!='/c/userdata'&& $route.path!='/c/affordable-housing-locator'" style="text-transform:none;" color="#286738" class="animate__animated animate__fadeInRight animate_slower"  dark large to="/c/userdata">Try the App</v-btn>
      </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>
<style>
.mima{
  font-family: 'Ubuntu', sans-serif;
  
}
</style>
